import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";
import { Image } from "antd";
import noImg from "../../../../../assets/images/not-found.jpg";

export const SellosSalidaVerificadora = ({widthFull}: {widthFull: string}) => {

  const adhesivoCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.adhesivoCheckPhoto
  );
  const cableVerificadoraCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.cableVerificadoraCheckPhoto
  );
  const botellaVerificadoraRastreoCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaVerificadoraRastreoCheckPhoto
  );
  const numRastreoSatelitalCheckPhoto = useWorkflowCheckpointStore(
    (state) => state.numRastreoSatelitalCheckPhoto
  );


  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
          <EtiquetaPuertaPhoto widthFull={widthFull} />
        </div>
        <Image
          src={adhesivoCheckPhoto === "" ? noImg : adhesivoCheckPhoto}
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
        <SelloCablePhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            cableVerificadoraCheckPhoto === ""
              ? noImg
              : cableVerificadoraCheckPhoto
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
        <SelloRastreoPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            botellaVerificadoraRastreoCheckPhoto === ""
              ? noImg
              : botellaVerificadoraRastreoCheckPhoto
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ m: 1, display: "flex", justifyContent: "space-evenly" }}
      >
        <div style={{ width: widthFull === "xs" ? "240px" : "320px" }}>
        <NumRasteoPhoto widthFull={widthFull} />
        </div>
        <Image
          src={
            numRastreoSatelitalCheckPhoto === ""
              ? noImg
              : numRastreoSatelitalCheckPhoto
          }
          style={{
            width: 36,
            height: 36,
            borderRadius: 5,
            boxShadow: "0px 10px 15px 0px rgba(0,0,0,0.1)",
          }}
        />
      </Grid>
    </Grid>
  );
};

//SELLO SALIDA VERIFICADORA

const EtiquetaPuertaPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openAdhesivo,
    handleClose: handleCloseAdhesivo,
    handleOpen: handleOpenAdhesivo,
  } = useOpen();

  const adhesivoPhoto = useWorkflowCheckpointStore(
    (state) => state.adhesivoPhoto
  );

  const setAdhesivoPhoto = useWorkflowCheckpointStore(
    (state) => state.setAdhesivoPhoto
  );
  const fotoUrl = useBlobUrl(adhesivoPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      label="ETIQUETA PUERTA"
      handleClose={handleCloseAdhesivo}
      handleOpen={handleOpenAdhesivo}
      open={openAdhesivo}
      setFoto={setAdhesivoPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const SelloCablePhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openCableVerificadora,
    handleClose: handleCloseCableVerificadora,
    handleOpen: handleOpenCableVerificadora,
  } = useOpen();

  const cableVerificadoraPhoto = useWorkflowCheckpointStore(
    (state) => state.cableVerificadoraPhoto
  );

  const setCableVerificadoraPhoto = useWorkflowCheckpointStore(
    (state) => state.setCableVerificadoraPhoto
  );
  const fotoUrl = useBlobUrl(cableVerificadoraPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl!}
      handleClose={handleCloseCableVerificadora}
      handleOpen={handleOpenCableVerificadora}
      label="SELLO CABLE"
      open={openCableVerificadora}
      width={widthFull === "xs" ? 150 : 220}
      setFoto={setCableVerificadoraPhoto}
    />
  );
};

const SelloRastreoPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openBotellaVerificadoraRastreo,
    handleClose: handleCloseBotellaVerificadoraRastreo,
    handleOpen: handleOpenBotellaVerificadoraRastreo,
  } = useOpen();

  const botellaVerificadoraRastreoPhoto = useWorkflowCheckpointStore(
    (state) => state.botellaVerificadoraRastreoPhoto
  );

  const setBotellaVerificadoraRastreoPhoto = useWorkflowCheckpointStore(
    (state) => state.setBotellaVerificadoraRastreoPhoto
  );
  const fotoUrl = useBlobUrl(botellaVerificadoraRastreoPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseBotellaVerificadoraRastreo}
      handleOpen={handleOpenBotellaVerificadoraRastreo}
      label="SELLO RASTREO"
      open={openBotellaVerificadoraRastreo}
      setFoto={setBotellaVerificadoraRastreoPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};

const NumRasteoPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openNumRastreoSatelital,
    handleClose: handleCloseNumRastreoSatelital,
    handleOpen: handleOpenNumRastreoSatelital,
  } = useOpen();

  const numRastreoSatelitalPhoto = useWorkflowCheckpointStore(
    (state) => state.numRastreoSatelitalPhoto
  );

  const setNumRastreoSatelitalPhoto = useWorkflowCheckpointStore(
    (state) => state.setNumRastreoSatelitalPhoto
  );
  const fotoUrl = useBlobUrl(numRastreoSatelitalPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl!}
      handleClose={handleCloseNumRastreoSatelital}
      handleOpen={handleOpenNumRastreoSatelital}
      label="N° RASTREO"
      open={openNumRastreoSatelital}
      setFoto={setNumRastreoSatelitalPhoto}
      width={widthFull === "xs" ? 150 : 220}
    />
  );
};
